export default __webpack_public_path__ + "static/media/pastelito-maracucho.7333bd6a.jpg";